var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Calque_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  style: {
    enableBackground: "new 0 0 1000 1000"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M492.9,230.6c-22.2-21.9-44.3-43.8-66.4-65.7c-25.8-25.6-51.3-51.5-77.6-76.6c-27.8-26.5-72.2-14.6-83.1,22.1 c-6.5,21.8-0.4,40.3,15.4,55.8c73.6,72.4,147.1,144.8,220.7,217.2c22,21.7,44.3,43,65.7,65.3c14.6,15.2,27.8,31.7,42.5,48.6 c-3.4,3.8-9.1,10.8-15.3,17.2c-34.5,35.4-69.2,70.5-103.6,106c-50.6,52.2-101,104.7-151.5,157c-19,19.7-37.9,39.4-56.9,59.1 c-13.7,14.2-18.2,31.4-13.6,50.4c9.6,39.8,57,52.4,85.9,22.9c50.3-51.3,100.5-102.7,150.4-154.3c68.7-70.9,137.1-142.1,205.6-213.1 c3-3.1,6.1-6.3,9-9.6c22.9-26,22.1-56.8-2.4-81C642.8,378,567.9,304.3,492.9,230.6z"
})));
export default SvgIconArrow;